import { Component } from '@angular/core';
import { toolbarBackdropClass } from '../../constants';

@Component({
  selector: 'y42-show-more-menu-button',
  templateUrl: './show-more-menu-button.component.html',
  styleUrls: ['./show-more-menu-button.component.scss'],
})
export class ShowMoreMenuButtonComponent {
  toolbarBackdropClass = toolbarBackdropClass;
}
